/*
  Studio Fedde · koopknop op de productpagina (configurator) voor mobiel (< 750px).

  - Een knop naast de prijs (.sf-atc--inline) voegt in één tik toe, in plaats van eerst een paneel te openen.
  - Zodra die knop uit beeld is, verschijnt onderaan een sticky balk met prijs + dezelfde knop (.sf-atc-sticky).
  - Beide knoppen sturen het echte formulier in via de (verborgen) submitknop; de bestaande product-form-logica
    (fetch naar /cart/add, cart drawer openen, foutmeldingen) blijft dus ongewijzigd.
  - Label en disabled-staat volgen die echte submitknop (uitverkocht, bezig met toevoegen).
  - De chatbubbel schuift omhoog zolang de sticky balk zichtbaar is, zodat hij de knop niet bedekt, en wordt op
    mobiel verborgen zolang de cart drawer open is (anders ligt hij over 'Direct afrekenen').

  De configurator bouwt het formulier met JavaScript in de pagina en kan het opnieuw opbouwen. Daarom zoekt dit script
  zijn elementen steeds opnieuw op en luistert het met één klik-handler op het document.
*/
(function () {
  if (window.sfPdpAtc) return;
  window.sfPdpAtc = true;

  var mobile = window.matchMedia('(max-width: 749px)');
  var observedInline = null;
  var io = null;
  var inlineVisible = true;
  var chatReady = false;

  function parts() {
    var pf = document.querySelector('product-form');
    if (!pf) return null;
    var inline = pf.querySelector('.sf-atc--inline');
    var sticky = pf.querySelector('[data-sf-atc-sticky]');
    var real = pf.querySelector('.product-form__buttons [type="submit"]');
    var form = pf.querySelector('form');
    if (!inline || !sticky || !real || !form) return null;
    return { pf: pf, inline: inline, sticky: sticky, real: real, form: form };
  }

  function isOff(real) {
    return real.disabled || real.getAttribute('aria-disabled') === 'true';
  }

  // Klik op één van de twee knoppen: het echte formulier insturen
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sf-atc]') : null;
    if (!btn) return;
    var p = parts();
    if (!p) return;
    e.preventDefault();
    if (isOff(p.real) || p.real.classList.contains('loading')) return;
    if (typeof p.form.requestSubmit === 'function') p.form.requestSubmit(p.real);
    else p.real.click();
  });

  function syncButtons(p) {
    var label = p.real.querySelector('span');
    var text = label ? label.textContent.trim() : '';
    var off = isOff(p.real);
    var busy = p.real.classList.contains('loading');
    p.pf.querySelectorAll('[data-sf-atc]').forEach(function (btn) {
      var l = btn.querySelector('[data-sf-atc-label]');
      if (l && text && l.textContent !== text) l.textContent = text;
      if (off && btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
      if (!off && btn.hasAttribute('aria-disabled')) btn.removeAttribute('aria-disabled');
      if (btn.disabled !== p.real.disabled) btn.disabled = p.real.disabled;
      if (btn.classList.contains('is-loading') !== busy) btn.classList.toggle('is-loading', busy);
    });
  }

  function syncPrice(p) {
    var box = p.pf.querySelector('.product__price');
    var slot = p.sticky.querySelector('[data-sf-atc-price]');
    if (!box || !slot) return;
    var sale = box.querySelector('.price__sale .price-item--sale');
    var reg = box.querySelector('.price__regular .price-item--regular');
    var was = box.querySelector('.price__sale s.price-item--regular');
    var now = (sale && sale.textContent.trim()) || (reg && reg.textContent.trim()) || '';
    var wasText = was ? was.textContent.trim() : '';
    var key = now + '|' + wasText;
    if (slot.getAttribute('data-key') === key) return;
    slot.setAttribute('data-key', key);
    slot.innerHTML = '';
    var n = document.createElement('span');
    n.className = 'sf-atc-sticky__now';
    n.textContent = now;
    slot.appendChild(n);
    if (wasText && wasText !== now) {
      var w = document.createElement('s');
      w.className = 'sf-atc-sticky__was';
      w.textContent = wasText;
      slot.appendChild(w);
    }
  }

  // Chatbubbel (shopify-chat, open shadow-DOM): omhoog schuiven en eventueel verbergen
  function liftChat(px, hide) {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return;
    if (!chat.shadowRoot.querySelector('style[data-sf-lift]')) {
      var st = document.createElement('style');
      st.setAttribute('data-sf-lift', '');
      st.textContent = '.activator-nudge { bottom: calc(20px + var(--sf-chat-lift, 0px)) !important; opacity: var(--sf-chat-opacity, 1); visibility: var(--sf-chat-visibility, visible); transition: bottom 0.25s ease, opacity 0.2s ease; }';
      chat.shadowRoot.appendChild(st);
    }
    var v = px + 'px';
    if (chat.style.getPropertyValue('--sf-chat-lift') !== v) chat.style.setProperty('--sf-chat-lift', v);
    var o = hide ? '0' : '1';
    if (chat.style.getPropertyValue('--sf-chat-opacity') !== o) {
      chat.style.setProperty('--sf-chat-opacity', o);
      chat.style.setProperty('--sf-chat-visibility', hide ? 'hidden' : 'visible');
    }
  }

  function drawerOpen() {
    return mobile.matches && !!document.querySelector('cart-drawer.active');
  }

  function applySticky(p) {
    var show = mobile.matches && !inlineVisible;
    if (document.body.classList.contains('sf-atc-sticky-on') !== show) document.body.classList.toggle('sf-atc-sticky-on', show);
    var hidden = show ? 'false' : 'true';
    if (p.sticky.getAttribute('aria-hidden') !== hidden) p.sticky.setAttribute('aria-hidden', hidden);
    var stickyBtn = p.sticky.querySelector('[data-sf-atc]');
    if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    if (show) document.documentElement.style.setProperty('--sf-sticky-h', p.sticky.offsetHeight + 'px');
    liftChat(show ? p.sticky.offsetHeight + 8 : 0, drawerOpen());
  }

  function observeInline(p) {
    if (observedInline === p.inline || !('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    observedInline = p.inline;
    io = new IntersectionObserver(function (entries) {
      inlineVisible = entries[0].isIntersecting;
      var cur = parts();
      if (cur) applySticky(cur);
    }, { threshold: 0.6 });
    io.observe(p.inline);
  }

  function tick() {
    var p = parts();
    if (!p) {
      if (document.body.classList.contains('sf-atc-sticky-on')) document.body.classList.remove('sf-atc-sticky-on');
      liftChat(0, drawerOpen());
      return;
    }
    syncButtons(p);
    syncPrice(p);
    observeInline(p);
    applySticky(p);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; tick(); });
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled']
  });
  if (mobile.addEventListener) mobile.addEventListener('change', schedule); else mobile.addListener(schedule);

  // De chat laadt later in; blijf even kijken zodat de stijlregel erin komt
  var tries = 0;
  (function pollChat() { tick(); if (tries++ < 40) setTimeout(pollChat, 500); })();
})();
